import { useState } from "react";
import { FileText, Download, Eye, Search, ShieldCheck } from "lucide-react";
import { DOCUMENTOS, CATEGORIAS_DOCS } from "../data/siteData";

export const Transparencia = () => {
  const [busca, setBusca] = useState("");
  const [categoria, setCategoria] = useState("Todos");
  const docs = DOCUMENTOS.filter(
    (d) =>
      (categoria === "Todos" || d.categoria === categoria) &&
      d.titulo.toLowerCase().includes(busca.toLowerCase())
  );

  return (
    <section id="transparencia" className="relative bg-[#0F0F11] py-24 overflow-hidden" data-testid="transparencia-section">
      <span aria-hidden className="absolute -right-8 top-0 text-[14rem] leading-none font-heading text-white/[0.03] select-none pointer-events-none">道</span>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 relative z-10">
        <div className="flex items-center gap-2 text-[#DC2626] mb-4">
          <ShieldCheck className="h-4 w-4" />
          <p className="text-xs font-semibold uppercase tracking-[0.3em]">Transparência TCM-PA</p>
        </div>
        <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-semibold text-[#F8FAF8] tracking-tight max-w-2xl" data-testid="transparencia-title">
          Portal da Transparência e Prestação de Contas
        </h2>
        <p className="mt-6 text-base sm:text-lg text-zinc-400 leading-relaxed max-w-3xl">
          Em atenção aos critérios de comprovação e transparência do Tribunal de Contas dos Municípios do Pará, a AMACLI publica aqui seus documentos oficiais e demonstrativos de prestação de contas.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row gap-4 sm:items-center">
          <div className="relative flex-1 max-w-md">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-zinc-500" />
            <input
              type="text"
              placeholder="Buscar documento..."
              value={busca}
              onChange={(e) => setBusca(e.target.value)}
              data-testid="transparencia-busca-input"
              className="w-full bg-[#202026] border border-white/10 focus:border-[#DC2626] rounded-full pl-10 pr-4 py-2.5 text-sm text-zinc-200 placeholder-zinc-500 outline-none transition-colors duration-200"
            />
          </div>
          <div className="flex flex-wrap gap-2" data-testid="transparencia-categorias">
            {CATEGORIAS_DOCS.map((c) => (
              <button
                key={c}
                onClick={() => setCategoria(c)}
                data-testid={`transparencia-filtro-${c.toLowerCase().replace(/ /g, "-")}`}
                className={`text-xs font-semibold px-4 py-2 rounded-full border transition-colors duration-200 ${
                  categoria === c
                    ? "bg-[#DC2626] border-[#DC2626] text-white"
                    : "border-white/15 text-zinc-400 hover:border-[#DC2626]/60 hover:text-zinc-200"
                }`}
              >
                {c}
              </button>
            ))}
          </div>
        </div>

        {docs.length === 0 ? (
          <p className="mt-10 text-sm text-zinc-500" data-testid="transparencia-vazio">
            Nenhum documento publicado nesta categoria no momento. Novos documentos de prestação de contas serão disponibilizados em breve.
          </p>
        ) : (
          <div className="mt-10 grid sm:grid-cols-2 gap-6">
            {docs.map((d, i) => {
              const url = `${process.env.PUBLIC_URL}/${d.arquivo}`;
              return (
                <article key={d.titulo} className="bg-[#202026] border border-white/10 hover:border-[#DC2626]/60 rounded-xl p-6 flex gap-5 transition-colors duration-200" data-testid={`transparencia-doc-${i + 1}`}>
                  <div className="shrink-0 h-12 w-12 rounded-lg bg-[#DC2626]/15 border border-[#DC2626]/30 flex items-center justify-center">
                    <FileText className="h-6 w-6 text-[#EF4444]" />
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center gap-2 flex-wrap">
                      <h3 className="font-heading text-lg font-medium text-[#F8FAF8]">{d.titulo}</h3>
                      <span className="text-[10px] font-mono font-semibold bg-[#DC2626]/20 text-[#EF4444] px-2 py-0.5 rounded">PDF</span>
                      <span className="text-[10px] font-mono text-zinc-500">{d.ano}</span>
                    </div>
                    <p className="mt-2 text-sm text-zinc-400 leading-relaxed">{d.descricao}</p>
                    <div className="mt-4 flex gap-3">
                      <a href={url} target="_blank" rel="noopener noreferrer" data-testid={`transparencia-visualizar-${i + 1}`} className="inline-flex items-center gap-1.5 text-xs font-semibold text-zinc-200 border border-white/15 hover:border-[#DC2626] px-3 py-1.5 rounded-full transition-colors duration-200">
                        <Eye className="h-3.5 w-3.5" /> Visualizar
                      </a>
                      <a href={url} download data-testid={`transparencia-baixar-${i + 1}`} className="inline-flex items-center gap-1.5 text-xs font-semibold bg-[#DC2626] hover:bg-[#EF4444] text-white px-3 py-1.5 rounded-full transition-colors duration-200">
                        <Download className="h-3.5 w-3.5" /> Baixar PDF
                      </a>
                    </div>
                  </div>
                </article>
              );
            })}
          </div>
        )}

        <p className="mt-12 text-xs text-zinc-500 leading-relaxed max-w-3xl border-t border-white/10 pt-6" data-testid="transparencia-selo">
          Compromisso público: a AMACLI mantém suas contas abertas à fiscalização da comunidade e dos órgãos competentes, em conformidade com as diretrizes do TCM-PA. Documentos adicionais podem ser solicitados pelo canal de contato.
        </p>
      </div>
    </section>
  );
};
